export interface SemaphoreObject {
  type?: string;
  text?: string;
}

export class BaseAccountDetailComponent {
  public overdueTooltipText!: string;
  public successTooltipText!: string;
  public greyTooltipText!: string;

  public setTooltips(semaphoreValue: string): SemaphoreObject {
    switch (semaphoreValue) {
      case 'green':
        return {
          type: 'success',
          text: this.successTooltipText,
        };
      case 'red':
        return {
          type: 'danger',
          text: this.overdueTooltipText,
        };
      case 'gray':
        return {
          type: 'grey',
          text: this.greyTooltipText,
        };
      default:
        return {};
    }
  }
}
